@if (!isLoading) {
  <div class="main-container" data-cy="patient-portal-contacts-main-container">
    <div class="information-object" data-cy="patient-portal-contacts-info-object-container">
      @if (dataPatientContactObjs.length == 0) {
        <div class="contact-warning" data-cy="patient-portal-contacts-warning-text">
          Please add an emergency contact.
        </div>
      }
      <mat-accordion data-cy="patient-portal-contacts-accordion">
        @for (contactObj of dataPatientContactObjs; track contactObj; let i = $index) {
          <mat-expansion-panel class="information-container" [expanded]="activeIndex === i" data-cy="patient-portal-contacts-expansion-panel">
            <mat-expansion-panel-header class="full-header" data-cy="patient-portal-contacts-expansion-panel-header">
              <mat-panel-title data-cy="patient-portal-contacts-panel-title">
                {{ contactObj.dataContact.FirstName }} {{ contactObj.dataContact.LastName }}
              </mat-panel-title>
            </mat-expansion-panel-header>
            <mat-panel-description data-cy="patient-portal-contacts-panel-description">
            </mat-panel-description>
            <mat-form-field class="input-field input-field-full" data-cy="patient-portal-contacts-firstname-form-field">
              <mat-label data-cy="patient-portal-contacts-firstname-label">First Name</mat-label>
              <input matInput [(ngModel)]="contactObj.dataContact.FirstName" required data-cy="patient-portal-contacts-firstname-input">
            </mat-form-field>
            <mat-form-field class="input-field input-field-full" data-cy="patient-portal-contacts-lastname-form-field">
              <mat-label data-cy="patient-portal-contacts-lastname-label">Last Name</mat-label>
              <input matInput [(ngModel)]="contactObj.dataContact.LastName" required data-cy="patient-portal-contacts-lastname-input">
            </mat-form-field>
            <mat-form-field class="input-field" data-cy="patient-portal-contacts-relationship-form-field">
              <mat-label data-cy="patient-portal-contacts-relationship-label">Relationship</mat-label>
              <mat-select [(ngModel)]="contactObj.dataPatientContact.enumPatientContactTypeID" required data-cy="patient-portal-contacts-relationship-select-input">
                @for (option of enumContactRelationships; track option) {
                  <mat-option [value]="option.ValidValueItemId" data-cy="patient-portal-contacts-relationship-option">
                    {{option.ItemDisplayValue}}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
            <mat-form-field class="input-field" data-cy="patient-portal-contacts-dob-form-field">
              <mat-label data-cy="patient-portal-contacts-dob-label">Date of Birth</mat-label>
              <input matInput [matDatepicker]="picker2" [(ngModel)]="contactObj.dataContact.BirthDate" required data-cy="patient-portal-contacts-dob-input">
              <mat-datepicker-toggle matSuffix [for]="picker2" data-cy="patient-portal-contacts-dob-datepicker-toggle"></mat-datepicker-toggle>
              <mat-datepicker #picker2 data-cy="patient-portal-contacts-dob-datepicker"></mat-datepicker>
            </mat-form-field>
            <div class="input-section-header" data-cy="patient-portal-contacts-address-header-text">
              Address
              <div class="input-field input-field-medium" data-cy="patient-portal-contacts-import-address-button-container">
                <button mat-button color="primary" class="tdo-button tdo-save" (click)="sameAddressChange(contactObj.dataAddress)" data-cy="patient-portal-contacts-import-address-action-button">Import my address</button>
              </div>
            </div>
            <mat-form-field class="input-field input-field-full" data-cy="patient-portal-contacts-address1-form-field">
              <mat-label data-cy="patient-portal-contacts-address1-label">Address Line 1</mat-label>
              <input matInput [(ngModel)]="contactObj.dataAddress.Address1" required data-cy="patient-portal-contacts-address1-input">
            </mat-form-field>
            <mat-form-field class="input-field input-field-full" data-cy="patient-portal-contacts-address2-form-field">
              <mat-label data-cy="patient-portal-contacts-address2-label">Address Line 2</mat-label>
              <input matInput [(ngModel)]="contactObj.dataAddress.Address2" data-cy="patient-portal-contacts-address2-input">
            </mat-form-field>
            <mat-form-field class="input-field input-field-medium" data-cy="patient-portal-contacts-city-form-field">
              <mat-label data-cy="patient-portal-contacts-city-label">City</mat-label>
              <input matInput [(ngModel)]="contactObj.dataAddress.City" required data-cy="patient-portal-contacts-city-input">
            </mat-form-field>
            <mat-form-field class="input-field input-field-medium" data-cy="patient-portal-contacts-state-form-field">
              <mat-label data-cy="patient-portal-contacts-state-label">State</mat-label>
              <mat-select [(ngModel)]="contactObj.dataAddress.enumStateProvinceID" required data-cy="patient-portal-contacts-state-select-input">
                @for (option of stateListEnums; track option) {
                  <mat-option [value]="option.ValidValueItemId" data-cy="patient-portal-contacts-state-option">
                    {{option.ItemDisplayValue}}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
            <mat-form-field class="input-field input-field-small" data-cy="patient-portal-contacts-zipcode-form-field">
              <mat-label data-cy="patient-portal-contacts-zipcode-label">Zipcode</mat-label>
              <input matInput [(ngModel)]="contactObj.dataAddress.PostCode" required data-cy="patient-portal-contacts-zipcode-input">
            </mat-form-field>
            <div class="input-section-header" data-cy="patient-portal-contacts-contact-method-header-text">
              Contact Method
            </div>
            <mat-form-field class="input-field-medium" data-cy="patient-portal-contacts-phone-type-form-field">
              <mat-label data-cy="patient-portal-contacts-phone-type-label">Phone Type</mat-label>
              <mat-select [(ngModel)]="contactObj.dataComm.enumCommMethodID" required data-cy="patient-portal-contacts-phone-type-select-input">
                @for (option of enumContactMethods; track option) {
                  <mat-option [value]="option.ValidValueItemId" data-cy="patient-portal-contacts-phone-type-option">
                    {{option.ItemDisplayValue}}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
            <mat-form-field class="input-field input-field-medium" data-cy="patient-portal-contacts-phone-number-form-field">
              <mat-label data-cy="patient-portal-contacts-phone-number-label">Phone Number</mat-label>
              <input matInput type="tel" [(ngModel)]="contactObj.dataComm.Address" required data-cy="patient-portal-contacts-phone-number-input">
            </mat-form-field>
            <div class="info-action-container" data-cy="patient-portal-contacts-delete-action-container">
              <button mat-button class="tdo-button tdo-save" (click)="markAsDeleted(contactObj)" color="warn" data-cy="patient-portal-contacts-delete-action-button">Delete</button>
            </div>
          </mat-expansion-panel>
        }
      </mat-accordion>
      <div class="add-contact-button-container" data-cy="patient-portal-contacts-add-contact-action-button-container">
        <button mat-button color="primary" class="tdo-button tdo-save" (click)="onAddContactPressed()" data-cy="patient-portal-contacts-add-contact-action-button">Add an emergency contact</button>
      </div>
      @if (!disableSaveButton) {
        <div class="input-field input-field-full" data-cy="patient-portal-contacts-save-button-container">
          <button mat-raised-button color="primary" class="tdo-button tdo-save" (click)="savePatientContacts()" data-cy="patient-portal-contacts-save-action-button">Save</button>
        </div>
      }
    </div>
  </div>
}

@if (isLoading) {
  <div class="spinner-container" data-cy="patient-portal-contacts-loading-spinner-container">
    <mat-spinner data-cy="patient-portal-contacts-loading-spinner"></mat-spinner>
  </div>
}
